import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { RrsTemplateLevelCreate } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    RrsCategoryFilters,

    SortRrsCategories,
    PrepareRrsCategoryNestedIds,
    SaveRrsTemplateLevel,
    LoadAllRrsTemplateLevels,
    SetRrsTemplateRiskMapGenerated,

    setRrsTemplateCategoriesCategoryIds,
    setRrsTemplateCategoriesFilters,
    setRrsTemplateCategoriesSelected,
    setRrsTemplateEditLoadState,
    setRrsTemplateLevelList,
    setRrsTemplateEdit,
    closeModal,

    initRrsTemplateLevel,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Button,
    Table,
    TableSearchWrapper,
    SpinnerIcon,
} from "client/components"

import RrsCategorySearch from "client/pages/search/rrsCategorySearch"
import Columns from "./columns"

let isMounted: boolean

interface SelectCategoryProps {
    labelId: number
    categoryId: number
}

const SelectCategory = ({
    labelId,
    categoryId,
}: SelectCategoryProps) => {
    const template = useSelector((state: StoreType) => state.rrsTemplate.templateEdit)
    const categoryList = useSelector((state: StoreType) => state.rrsTemplate.categories.categoryList)
    const categoryIds = useSelector((state: StoreType) => state.rrsTemplate.categories.categoryIds)
    const filters = useSelector((state: StoreType) => state.rrsTemplate.categories.filters)
    const selected = useSelector((state: StoreType) => state.rrsTemplate.categories.selected)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const categoriesFiltered = SortRrsCategories(Object.values(categoryList), filters)
        const groupedIds = PrepareRrsCategoryNestedIds(categoriesFiltered)
        dispatch(setRrsTemplateCategoriesCategoryIds(groupedIds))
    }, [categoryList, filters])

    const onFilter = (newFilters: RrsCategoryFilters) => {
        dispatch(setRrsTemplateCategoriesFilters(newFilters))
    }

    const addLevels = () => {
        setSaveState(PENDING)
        const promiseArray: Promise<any>[] = []

        selected.forEach((selectedId) => {
            const selectedCategory = categoryList[selectedId]
            if (selectedCategory) {
                const newLevel: RrsTemplateLevelCreate = {
                    ...initRrsTemplateLevel,
                    labelId,
                    categoryId: categoryId || null,
                    name: selectedCategory.name,
                    shortName: selectedCategory.shortName.length ? selectedCategory.shortName : selectedCategory.name,
                    description: selectedCategory.description.length ? selectedCategory.description : "Add description here",
                    order: selectedCategory.order || 0,
                }
                promiseArray.push(SaveRrsTemplateLevel(null, newLevel, lang))
            }
        })

        Promise.all(promiseArray).then(() => {
            if (isMounted) {
                setSaveState(IDLE)
                dispatch(closeModal())
            }

            dispatch(setRrsTemplateCategoriesSelected(null))

            dispatch(setRrsTemplateEditLoadState(PENDING))
            LoadAllRrsTemplateLevels(labelId).then((levels) => {
                dispatch(setRrsTemplateLevelList(labelId, levels))

                SetRrsTemplateRiskMapGenerated([template.id], false).then(() => { // set riskMapGenerated to "false"
                    dispatch(setRrsTemplateEdit({
                        ...template,
                        riskMapGenerated: false,
                    }))
                    dispatch(setRrsTemplateEditLoadState(IDLE))
                })
            })
        })
    }

    const columns = Columns()

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.selectCategories}</PageTitle>
            </PageHeader>
            <PageContent>
                <TableSearchWrapper>
                    <RrsCategorySearch
                        id="rrsCategoryList"
                        filters={filters}
                        onFilter={onFilter}
                    />
                </TableSearchWrapper>
                <Table
                    columns={columns}
                    dataList={categoryList}
                    dataGroupedIds={categoryIds}
                    selectedIds={selected}
                    rowSize="sm"
                    showPagination
                />
                <PageForm>
                    <Button
                        variant="success"
                        disabled={!selected || !selected.length}
                        onClick={addLevels}
                    >
                        {saveState === PENDING ? <SpinnerIcon /> : lang.select}
                    </Button>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default SelectCategory
